<template>
	<div class="en_head_wrap">
		<div class="en_head_box flex1">
			<div class="head_con flex3">
				<img class="hc_left" v-show="jcinfo.logo" @click="goHome" :src="staticImg+jcinfo.logo" />
				<div class="hc_right flex3">
					<div class="hr_item" v-for="(item, index) in headList2" :key="item.title" @click.stop="navClick(index, item)"
						:class="enAct1 == index ? 'act_sty22' : ''">
						<span class="nv_tit">{{ item.title }}</span>
					</div>
				</div>
			</div>
			<div class="search_btn flex2">
				<img @click="handleSearch" src="@/images/header/zoom3.png" />
                <!-- <span @click="languageChange">CN</span> -->
			</div>
			<el-collapse-transition>
				<div class="se_box" v-show="seshow">
					<div class="se_con flex3">
						<input type="text" v-model="newsKey" placeholder="please enter keywords" class="ant_input" />
						<button @click="toSearch">
							<img src="@/images/header/search2.png" />
						</button>
					</div>
				</div>
			</el-collapse-transition>
		</div>
	</div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
	data() {
		return {
			seshow: false,
			sortArr: [],
			staticImg: this.$staticImg,
			newsKey: '',
			jcinfo: {},
		};
	},
	computed: {
		...mapState(["language","headList2", "enAct1"]),
	},
	created() {
		this.basicInfo();
	},
	methods: {
		...mapActions(["changeNav2","changeNav","changeTab"]),
        languageChange(){
            this.$store.state.language = 1;
            this.$router.push("/");
            this.$store.state.curtAct = null;
            this.$store.state.curtAct2 = null;
            this.$store.state.headAct = 0;
            this.$store.state.enAct1 = 0;
            localStorage.setItem('yuyan', 1);
        },
		async basicInfo() {
			const res = await this.$api.basicInfo();
			if (res.code == 1) {
				this.jcinfo = res.data;
			}
		},
		navClick(index, item) {
			this.changeNav2(index);
			if (item.id == 1) this.$router.push('/en/home');
			if (item.id == 2) this.$router.push('/en/about');//关于我们
			if (item.id == 3) this.$router.push('/en/productSort');//产品系列
			if (item.id == 4) this.$router.push('/en/historyCulture');//历史文化
			if (item.id == 5) this.$router.push('/en/advantage');//核心优势
			if (item.id == 8) this.$router.push('/en/contact');//联系我们
		},
		handleSearch() {
			this.seshow = !this.seshow;
		},
		toSearch() {
			if (!this.newsKey.trim()) {
				this.$message({
					message: 'please enter keywords',
					type: 'error',
					offset: 100,
					duration: 3000
				});
			} else {
				this.$router.push("/en/search?newsKey=" + this.newsKey);
				this.seshow = false;
			}
		},
		goHome() {
			this.$router.push('/en/home');
			this.changeNav2(0);
		}
	},
};
</script>
<style lang="scss">
.act_sty22 {
	background-color: #d43235 !important;
	border-bottom: 4px solid #d43235 !important;
	.nv_tit {
		color: #fff !important;
	}
}
.en_head_wrap {
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
	z-index: 3000;
	height: 80px;
	background-color: #fff;
	box-shadow: 0 6px 12px 0 hsla(0, 0%, 40%, 0.1);
	.en_head_box {
		width: 100%;
		cursor: pointer;
		padding: 0 40px;
		box-sizing: border-box;
		.search_btn {
			height: 80px;
			background-color: #fff;
			img {
				width: 25px;
                margin-top: 3px;
			}
            span{
                margin-left: 15px;
                font-size: 17px;
            }
		}
		.se_box {
			position: absolute;
			right: 15px;
			top: 76px;
			padding: 10px 0;
			width: 570px;
			.se_con {
				background-color: #fff;
				font-size: 0;
				border-radius: 5px;
				overflow: hidden;
				box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
				input {
					background-color: #fff;
					padding: 0 15px;
					color: #333;
					font-size: 14px;
					width: 480px;
					height: 50px;
					vertical-align: middle;
					outline: none;
					border: none;
				}
				button {
					outline: none;
					border: none;
					background-color: #d43235;
					background-image: url("/images/header/search2.png");
					background-repeat: no-repeat;
					height: 50px;
					width: 90px;
					vertical-align: middle;
					cursor: pointer;
				}
			}
		}
		.head_con {
			margin: 0 auto;
			flex: 1;
			height: 80px;
			.hc_left {
				width: 200px;
				height: auto;
			}
			.hc_right {
				margin-left: 290px;
				.hr_item {
					box-sizing: border-box;
					border-bottom: 4px solid #fff;
					height: 80px;
					.nv_tit {
						display: block;
						padding: 0 22px;
						color: #333;
						font-size: 16px;
						height: 80px;
						line-height: 80px;
						font-weight: bold;
					}
				}
			}
		}
	}
}

@media (max-width: 1700px) {
	.en_head_wrap {
		.en_head_box {
			.head_con {
				margin: 0 auto;
				flex: 1;
				.hc_left {
					width: 200px;
					height: auto;
				}
				.hc_right {
					margin-left: 260px;
					.hr_item {
						.nv_tit {
							padding: 0 22px;
						}
					}
				}
			}
		}
	}
}
@media (max-width: 1600px) {
	.en_head_wrap {
		.en_head_box {
			.head_con {
				margin: 0 auto;
				flex: 1;
				.hc_left {
					width: 180px;
					height: auto;
				}
				.hc_right {
					margin-left: 200px;
					.hr_item {
						.nv_tit {
							padding: 0 22px;
						}
					}
				}
			}
		}
	}
}
@media (max-width: 1500px) {
	.en_head_wrap {
		.en_head_box {
			.head_con {
				margin: 0 auto;
				flex: 1;
				.hc_left {
					width: 160px;
					height: auto;
				}
				.hc_right {
					margin-left: 110px;
					.hr_item {
						.nv_tit {
							padding: 0 18px;
						}
					}
				}
			}
		}
	}
}
@media (max-width: 1300px) {
	.en_head_wrap {
		.en_head_box {
			.head_con {
				margin: 0 auto;
				flex: 1;
				.hc_left {
					width: 120px;
					height: auto;
				}
				.hc_right {
					margin-left: 80px;
					.hr_item {
						.nv_tit {
							padding: 0 15px;
                            font-size: 14px;
						}
					}
				}
			}
		}
	}
}
@media (max-width: 1100px) {
	.en_head_wrap {
		.en_head_box {
			.head_con {
				margin: 0 auto;
				flex: 1;
				.hc_left {
					width: 100px;
					height: auto;
				}
				.hc_right {
					margin-left: 50px;
					.hr_item {
						.nv_tit {
							padding: 0 10px;
                            font-size: 14px;
						}
					}
				}
			}
		}
	}
}
@media (max-width: 950px) {
	.en_head_wrap {
		.en_head_box {
			.head_con {
				margin: 0 auto;
				flex: 1;
				.hc_left {
					width: 100px;
					height: auto;
				}
				.hc_right {
					display: none;
				}
			}
		}
	}
}
</style>